var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.586 5.58616C15.7705 5.39514 15.9912 5.24278 16.2352 5.13796C16.4792 5.03314 16.7416 4.97797 17.0072 4.97566C17.2728 4.97335 17.5361 5.02396 17.7819 5.12452C18.0277 5.22508 18.251 5.37359 18.4388 5.56137C18.6266 5.74916 18.7751 5.97246 18.8756 6.21825C18.9762 6.46405 19.0268 6.72741 19.0245 6.99296C19.0222 7.25852 18.967 7.52096 18.8622 7.76497C18.7574 8.00898 18.605 8.22967 18.414 8.41416L17.621 9.20716L14.793 6.37916L15.586 5.58616ZM13.379 7.79316L5 16.1722V19.0002H7.828L16.208 10.6212L13.378 7.79316H13.379Z",
    fill: "#172C34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.674003bff5118c52dc8f827653194fc9.svg";
export { ForwardRef as ReactComponent };